export default "__VITE_ASSET__6c1e8ae2__"